<script>
export default {
  props: ['breadcrumbs'],
};
</script>

<template>
  <div
    id="breadcrumbsDiv"
    v-if="
      breadcrumbs && breadcrumbs.breadcrumbItems && breadcrumbs.breadcrumbItems
    ">
    <div class="container">
      <div class="row">
        <div class="col">
          <nav id="breadcrumbs" class="miun-breadcrumbs">
            <div class="miun-fade-left"></div>
            <ul>
              <template v-for="breadcrumb in breadcrumbs.breadcrumbItems">
                <li v-if="breadcrumb.url">
                  <a :href="breadcrumb.url" :key="breadcrumb.url">{{
                    breadcrumb.title
                  }}</a>
                </li>
                <li class="no-arrow" v-else>
                  <span>{{ breadcrumb.title }}</span>
                </li>
              </template>
            </ul>
            <div class="miun-fade-right"></div>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>
